export default __webpack_public_path__ + "static/media/stock_details.14ad7102.svg";